export const formatDate = (date) => {
    return new Date(date).toLocaleDateString();
};

export const formatCurrency = (amount) => {
    return new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD'
    }).format(amount);
};

export const formatPercentage = (value) => {
    return `${(value * 100).toFixed(1)}%`;
};

export const formatNumber = (value) => {
    return new Intl.NumberFormat('en-US').format(value);
};

export const formatPhoneNumber = (phone) => {
    return phone.replace(/(\d{3})(\d{3})(\d{4})/, '($1) $2-$3');
};

export const formatAddress = (address) => {
    const parts = [
        address.street,
        address.city,
        address.state,
        address.zip
    ].filter(Boolean);
    return parts.join(', ');
}; 